interface ViewSwitcherProps {
  view: 'instructions' | 'monitor' | 'zborovi' | 'prava'
  onViewChange: (view: 'instructions' | 'monitor' | 'zborovi' | 'prava') => void
}

export function ViewSwitcher({ view, onViewChange }: ViewSwitcherProps) {
  const handleViewChange = (newView: 'instructions' | 'monitor' | 'zborovi' | 'prava') => {
    onViewChange(newView)
    // Update URL hash based on the view
    if (newView === 'instructions') {
      window.location.hash = ''
    } else {
      window.location.hash = `#${newView}`
    }
  }

  return (
    <div className="grid grid-cols-2 md:flex gap-1 md:gap-0 md:rounded-lg shadow-sm" role="group">
      <button
        type="button"
        onClick={() => handleViewChange('instructions')}
        className={`
          px-2 md:px-3 py-2 text-xs md:text-sm font-medium rounded-lg md:rounded-l-lg md:rounded-r-none border
          ${view === 'instructions'
            ? 'bg-blue-600 text-white border-blue-600 hover:bg-blue-700'
            : 'bg-white text-gray-700 border-gray-200 hover:bg-gray-50'
          }
        `}
      >
        <span className="flex items-center justify-center">
          <svg className="w-3 h-3 md:w-4 md:h-4 mr-1 md:mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
          </svg>
          <span className="hidden md:inline">Uputstva</span>
          <span className="md:hidden">Info</span>
        </span>
      </button>
      <button
        type="button"
        onClick={() => handleViewChange('monitor')}
        className={`
          px-2 md:px-3 py-2 text-xs md:text-sm font-medium rounded-lg md:rounded-none border md:border-l-0
          ${view === 'monitor'
            ? 'bg-blue-600 text-white border-blue-600 hover:bg-blue-700'
            : 'bg-white text-gray-700 border-gray-200 hover:bg-gray-50'
          }
        `}
      >
        <span className="flex items-center justify-center">
          <svg className="w-3 h-3 md:w-4 md:h-4 mr-1 md:mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          Monitor
        </span>
      </button>
      <button
        type="button"
        onClick={() => handleViewChange('zborovi')}
        className={`
          px-2 md:px-3 py-2 text-xs md:text-sm font-medium rounded-lg md:rounded-none border md:border-l-0
          ${view === 'zborovi'
            ? 'bg-blue-600 text-white border-blue-600 hover:bg-blue-700'
            : 'bg-white text-gray-700 border-gray-200 hover:bg-gray-50'
          }
        `}
      >
        <span className="flex items-center justify-center">
          <svg className="w-3 h-3 md:w-4 md:h-4 mr-1 md:mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
          Zborovi
        </span>
      </button>
      <button
        type="button"
        onClick={() => handleViewChange('prava')}
        className={`
          px-2 md:px-3 py-2 text-xs md:text-sm font-medium rounded-lg md:rounded-r-lg md:rounded-l-none border md:border-l-0
          ${view === 'prava'
            ? 'bg-blue-600 text-white border-blue-600 hover:bg-blue-700'
            : 'bg-white text-gray-700 border-gray-200 hover:bg-gray-50'
          }
        `}
      >
        <span className="flex items-center justify-center">
          <svg className="w-3 h-3 md:w-4 md:h-4 mr-1 md:mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
          </svg>
          <span className="hidden md:inline">Vaša prava</span>
          <span className="md:hidden">Prava</span>
        </span>
      </button>
    </div>
  )
} 